/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { parse, differenceInMinutes, parseISO, isBefore, addDays } from 'date-fns';
import _mapValues from 'lodash/mapValues';
import { Card, CardTitle } from 'components/Card';
import Message from 'components/Message';
import { bem, classNameWithModifiers as withMods } from 'helpers/class-name';
import messages from './ClasstivitySchedulerTable.messages';

import './ClasstivitySchedulerTable.scss';

const columns = [messages.startTime, messages.className, messages.duration, messages.teacherName];

export function duration(startTime, endTime) {
  let end = parse(endTime, 'HH:mm:ss', new Date());
  const start = parse(startTime, 'HH:mm:ss', new Date());
  // account for classes ending the next day
  if (isBefore(end, start)) end = addDays(end, 1);
  return differenceInMinutes(end, start);
}

const { block, element } = bem('classtivity-scheduler-table');

const ClasstivitySchedulerTable = ({ schedulesByDate }) => {
  const sortedDates = Object.keys(schedulesByDate).sort(
    (a, b) => parse(a, 'yyyy-MM-dd', new Date()) - parse(b, 'yyyy-MM-dd', new Date())
  );

  const sortedSchedulesByDate = _mapValues(schedulesByDate, value =>
    value.sort((a, b) => parse(a.startTime, 'HH:mm:ss', new Date()) - parse(b.startTime, 'HH:mm:ss', new Date()))
  );

  return sortedDates.map(date => (
    <Card className={block('mt+ grid grid--flush')} flush key={date}>
      <Message className="m-" as={CardTitle} value={parseISO(date)} format="short-w-dow" />

      <div>
        {columns.map(message => (
          <div key={message.id} className="grid__item 1/4 text--light text--center">
            <Message message={message} />
          </div>
        ))}
        <hr />
      </div>

      {sortedSchedulesByDate[date].map(schedule => (
        <div
          className={withMods(element('row'), { isNew: schedule._isNew, isDuplicate: schedule._isDuplicate }, 'mt-')}
          key={JSON.stringify(schedule)}>
          <div className="grid__item 1/4 text--center">
            <Message value={parse(schedule.startTime, 'HH:mm:ss', new Date())} format="time" />
          </div>
          <div className="grid__item 1/4 text--center">{schedule.className}</div>
          <div className="grid__item 1/4 text--center">{duration(schedule.startTime, schedule.endTime)}</div>
          <div className="grid__item 1/4 text--center">{schedule.resourceName}</div>
          <hr />
        </div>
      ))}
    </Card>
  ));
};

ClasstivitySchedulerTable.propTypes = {
  schedulesByDate: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        className: PropTypes.string,
        resourceName: PropTypes.string,
        startTime: PropTypes.string,
        endTime: PropTypes.string,
        _isNew: PropTypes.bool,
        _isDuplicate: PropTypes.bool,
      })
    )
  ),
};

export default ClasstivitySchedulerTable;
